// extracted by mini-css-extract-plugin
export default {"dataConsentForm":"dataConsentForm__JhOWoR","dataConsentFormItem":"dataConsentFormItem__n0kdDj"};